<template>
    <div id="app">
        <el-container class="main">
            <el-aside width="260px" class="left-nav">
                <Nav></Nav>
            </el-aside>
            <el-container>
                <!--<el-header :height="height" class="top-nav">-->
                    <!--<Header></Header>-->
                <!--</el-header>-->
                <el-main>
                    <router-view></router-view>
                    <!--<keep-alive>     &lt;!&ndash;使用keep-alive会将页面缓存&ndash;&gt;-->
                        <!--<router-view v-if="$route.meta.keepAlive"></router-view>-->
                    <!--</keep-alive>-->
                    <!--<router-view v-if="!$route.meta.keepAlive"></router-view>-->
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import bus from "./assets/js/EventBus.js";
    import Header from "./components/Header.vue";
    import Nav from "./components/Nav.vue";

    export default {
        name: "App",
        components: {
            Nav,
            Header
        },
        data() {
            return {
                height:'97px',
                breadlist:[],
            };
        },
        created() {
            bus.$on("Bread", e => {
                if(e.path.length>0){
                    this.height='130px'
                }else{
                    this.height='97px';
                };
            });
        }
    };
</script>

<style lang="less">
    @import "assets/css/common.css";
    @import "assets/css/itemcommon.css";
    @import "//at.alicdn.com/t/font_1209385_xnh51r3am5g.css";

    #app {
        width: 100%;
        height: 100%;
    }

    .main {
        height: 100%;
        width: 100%;
    }

    .el-main {
        background-color: #dadfe6;
        padding: 0;
    }

    .left-nav {
        background-color: #23262c;
        height: 100%;
        overflow-x: hidden;
        z-index: 99;
    }

    .top-nav {
        padding: 0;
        box-shadow: 0 0 10px #aaa;
        z-index: 9;
    }

    .right {
        float: right;
    }

    .el-tabs__nav-wrap::after {
        background-color: #fff;
    }

    .el-tabs__active-bar {
        bottom: 39px;
    }

    .is-opened .el-menu-item {
        background-color: #000 !important;
    }

    .el-badge {
        margin-top: -10px;
    }
</style>
